<div class="blue-feature">
    <app-feature-hero
    variant="ims"
    title="Network Fault Management"
    description="Detect, prioritize & resolve NMS issues with fault & incident handling features"
    image=""
    imageAlt=""
></app-feature-hero>

    <section class="container section-spacing">
        <div class="row mx-0 align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-text-left">
                    <h2 class="section-title">Tackle Your Downtime Issues With Smart Network Fault Management</h2>
                    <p class="section-paragraph">Infraon NMS scans all network devices to identify performance faults
                        like
                        poor connectivity or unexpected downtime with a pattern-based approach. Achieve high network
                        availability with integrated incident capabilities.</p>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-img-right justify-content-center">
                    <img src="/assets/img/feature-pages/infraon-ims/network-fault-management/fault-management.webp"
                        width="80%" alt="asset discovery status">
                </div>
            </div>
        </div>
    </section>

    <section class="container section-spacing">
        <div id="gdpr-wrapper">
            <div class="gdpr-section justify-content-center">
                <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
                <div>
                    <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                    <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
                </div>
            </div>
        </div>
    </section>

    <section class="container section-spacing">
        <h2 class="section-title text-center p-b-60">Feature Highlights</h2>

        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto"
                        src="/assets/img/feature-pages/infraon-ims/network-fault-management/airplay.svg"
                        alt="Airplay icon">
                </div>

                <p class="section-title-s">Automated Problem Diagnosis</p>
                <p class="section-paragraph-s">Zero-in, discover incident sources on problems with an automated
                    real-time
                    diagnosis of all network devices with root cause analysis to discover the incident sources.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto"
                        src="/assets/img/feature-pages/infraon-ims/network-fault-management/gear.svg" alt="gear icon">
                </div>

                <p class="section-title-s">Self-Healing Capabilities</p>
                <p class="section-paragraph-s">Predefine & integrate incident resolution workflows into your fault
                    management process to reduce manual work & fix network outages.</p>
            </div>
        </div>



        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto"
                        src="/assets/img/feature-pages/infraon-ims/network-fault-management/alert-octagon.svg"
                        alt="alert icon 2">
                </div>

                <p class="section-title-s">Advanced Reporting</p>
                <p class="section-paragraph-s">Equip teams with reporting insights to customize & share data on faults &
                    incidents - future-proofing network resilience.lex problems.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto"
                        src="/assets/img/feature-pages/infraon-ims/network-fault-management/bell-icon.svg"
                        alt="Bell Icon">
                </div>

                <p class="section-title-s">Alerts & Notifications</p>
                <p class="section-paragraph-s">Configure alerts & notifications to stay updated on emerging faults to
                    implement corrective measures & minimize downtimes.</p>
            </div>
        </div>
    </section>

    <section class="primary-bg">
        <div class="container section-spacing">
            <div class="row mx-0 d-flex align-items-center position-relative overflow-hidden bg-white-dots">
                <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                    <h2 class="section-title text-white">Other Features</h2>

                    <div class="row mx-0 px-0">
                        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Automated Network Discovery</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Automated Network Topology</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Network Performance Management</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Real-Time Network Monitoring</p>
                            </li>
                        </ul>

                        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Downtime Calculation</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Quality Of Service-Based Faults</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Fault Measure From Flow</p>
                            </li>
                            <li class="d-flex align-items-center my-3"><img class="me-3"
                                    src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg"
                                    alt="Checkmar icon">
                                <p class="section-paragraph text-white mb-0">Syslog-Based Fault Detection</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box position-absolute"
                    style="right: 0;bottom: 0;">
                    <img src="/assets/img/feature-pages/infraon-ims/network-fault-management/smiling-guys-3.webp"
                        class="w-80" alt="guy pointing at the features">
                </div>
            </div>
        </div>
    </section>

    <section class="section-spacing bg-grey">
        <div class="container" id="g2-box-wrapper">
            <div class="g2-box justify-content-between">
                <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
                <p>Already love using our products? Please <br> share your experiences on G2</p>
                <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
            </div>
        </div>
    </section>
</div>